import { render, staticRenderFns } from "./ImmunizationReportTable.vue?vue&type=template&id=43048417&scoped=true"
import script from "./ImmunizationReportTable.vue?vue&type=script&lang=js"
export * from "./ImmunizationReportTable.vue?vue&type=script&lang=js"
import style0 from "./ImmunizationReportTable.vue?vue&type=style&index=0&id=43048417&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43048417",
  null
  
)

export default component.exports